// extracted by mini-css-extract-plugin
export var accordion = "_gj-0";
export var chevron = "_gj-3";
export var closed = "_gj-2";
export var content = "_gj-4";
export var open = "_gj-1";
export var rotate = "_gj-5";